import { createSelector } from 'reselect'
import { StoreState } from '..'

export const isLoading = createSelector(
  ({ app }: StoreState) => app,
  (data) => data.isLoading
)

export const getErrors = createSelector(
  ({ app }: StoreState) => app,
  (data) => data.errors.message
)
